import { render, staticRenderFns } from "./LanguageSelector.vue?vue&type=template&id=445b9807&scoped=true"
import script from "./LanguageSelector.vue?vue&type=script&lang=js"
export * from "./LanguageSelector.vue?vue&type=script&lang=js"
import style0 from "./LanguageSelector.vue?vue&type=style&index=0&id=445b9807&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445b9807",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('445b9807')) {
      api.createRecord('445b9807', component.options)
    } else {
      api.reload('445b9807', component.options)
    }
    module.hot.accept("./LanguageSelector.vue?vue&type=template&id=445b9807&scoped=true", function () {
      api.rerender('445b9807', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LanguageSelector.vue"
export default component.exports